import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b2ff613"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "panelheader" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Confirm")
], -1))
const _hoisted_4 = { class: "align-content-center" }
const _hoisted_5 = { class: "mt-3 mb-3 neu-text--align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_ctx.msgValue), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onConfirmClick())),
          class: "neu-button--primary neu-button neu-button--raised adjustWidth"
        }, " Ok "),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCancelClick())),
          class: "neu-button--primary neu-button neu-button--raised adjustWidth ml-2"
        }, " Cancel ")
      ])
    ])
  ]))
}